export enum Gender {
  M = "Male",
  F = "Female",
}

export const mapDbGenderToEnum = (dbGender: string): Gender => {
  const genderMapping: { [key: string]: Gender } = {
    M: Gender.M,
    F: Gender.F,
  };

  return genderMapping[dbGender] || undefined; 
};